type OwnLocation = {
  name: string;
  street: string;
  city: string;
  mapLink: string;
  note?: string;
};

export const onboardingLocations: OwnLocation[] = [
  {
    name: 'SCC St. Gallen',
    street: 'Bahnhofplatz 2',
    city: '9000 St. Gallen',
    mapLink: 'https://maps.app.goo.gl/jdRM8d47HEHh8xPy8',
    note: 'Selber Haupteingang wie das Migros-Restaurant im Bahnhof St. Gallen, im Zwischengeschoss.',
  },
];

export const ownLocations: OwnLocation[] = [
  {
    name: 'SCC Wil',
    street: 'Dufourstrasse 8',
    city: '9500 Wil',
    mapLink:
      'https://www.google.com/maps/search/?api=1&query=Dufourstrasse+8+9500+Wil',
  },
];

export const partnerLocations: {
  name: string;
  street: string;
  city: string;
  mapLink: string;
}[] = [
  {
    name: 'Medbase Apotheke Jona',
    street: 'Molkereistrasse 10',
    city: '8645 Jona',
    mapLink: 'https://maps.app.goo.gl/zKbqNSJTjr5tAt5q9',
  },
  {
    name: 'Pill Apotheke Zentrum',
    street: 'Bahnhofstrasse 42',
    city: '9470 Buchs',
    mapLink: 'https://maps.app.goo.gl/6V3CYbKvesBc1bxr8',
  },
  {
    name: 'Apotheke zum Schwefelbad',
    street: 'St. Gallerstrasse 1',
    city: '7320 Sargans',
    mapLink: 'https://maps.app.goo.gl/bRxhpRs6ecvtZ51r5',
  },
  {
    name: 'Coop Vitality Apotheke Rorschach',
    street: 'Marktplatz 12',
    city: '9400 Rorschach',
    mapLink: 'https://maps.app.goo.gl/33L9NtBVK4eNs5fJ8',
  },
];
